export default __webpack_public_path__ + "static/media/Icons_12.2ed9a120.svg";